export default __webpack_public_path__ + "static/media/proffy.adb90949.jpg";